/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M12 6c1.2237 0 2.2763-.7327 2.743-1.7832 2.3495.828 4.2122 2.6909 5.0402 5.0402C18.7327 9.7237 18 10.7763 18 12c0 1.2237.7327 2.2763 1.7832 2.743-.828 2.3493-2.6907 4.2122-5.0402 5.0402C14.2763 18.7327 13.2237 18 12 18c-1.2237 0-2.2763.7327-2.743 1.7832-2.3496-.828-4.2123-2.691-5.0402-5.0402C5.2674 14.2763 6 13.2237 6 12c0-1.6569-1.3431-3-3-3-1.6568 0-3 1.3431-3 3 0 1.5611 1.1924 2.8438 2.7162 2.9867.959 2.9832 3.3143 5.3382 6.297 6.2971C9.1563 22.8076 10.439 24 12 24c1.5611 0 2.8438-1.1924 2.9867-2.7162 2.9829-.9589 5.3382-3.314 6.2971-6.2971C22.8076 14.8438 24 13.5611 24 12s-1.1924-2.8438-2.7162-2.9867c-.9589-2.983-3.3142-5.3382-6.2971-6.2971C14.8438 1.1924 13.5611 0 12 0c-1.6569 0-3 1.3432-3 3 0 1.6569 1.3431 3 3 3Z"
    clipRule="evenodd"
  />,
  'MenuLifecycleFilled'
);
